<div #widthMeasure class="w-full"></div>

@if (mode$|async; as mode) {
  <h2 class="text-lg font-medium mb-4">
    Foto's
    <vwui-badge class="ml-2 text-sm">{{((photoReferenceList$|async) || []).length}}</vwui-badge>
  </h2>
  @if (mode === 'Edit') {
    <app-file-upload-dnd-area (fileSelect)="onPhotoSelect($event)" [disabled]="sortActive$ | async">
      <div class="photos-grid" [appSortable]="sortablejsOptions">
        <ng-container>
          <div class="photos-grid-item photos-grid-item--first unsortable">
            <div class="photos-grid-item__content">
              <app-file-upload-button
                (fileSelect)="onPhotoSelect($event)"
                [accept]="fileAccept"
              ></app-file-upload-button>
            </div>
          </div>
          @for (photoItem of photoReferenceList$ | async; track trackByPositionAndFocus($index, photoItem)) {
            <div class="photos-grid-item">
              <div class="photos-grid-item__content sortable">
                <app-prd-photo
                  class="cursor-move"
                  [projectReferenceId]="_projectReferenceId"
                  [projectReferencePhoto]="photoItem"
                  [readonly]="false"
                  [staticThumbnail]="true"
                  (photoCreated)="onPhotoCreated()"
                  (photoDeleted)="refreshPhotoList()"
                  (photoUpdated)="refreshPhotoList()"
                  (photoUploadFailed)="onPhotoUploadFailed()"
                ></app-prd-photo>
              </div>
            </div>
          }
        </ng-container>
      </div>
    </app-file-upload-dnd-area>
  } @else {
    <app-overflow-content [cutoffHeight]="(cutoffHeight$|async)">
      @if (justifiedLayout$|async; as justifiedLayout) {
        <div class="justified-photo-grid" [style.--height]="(height$|async) + 'px'">
          @for (photoReference of justifiedLayout; track trackByPositionAndFocus($index, photoReference);) {
            <app-prd-photo class="justified-photo-grid__item cursor-pointer"
              [style.--left]="photoReference.left + 'px'" [style.--top]="photoReference.top + 'px'"
              [style.--width]="photoReference.width + 'px'"
              [style.--height]="photoReference.height  + 'px'"
              [projectReferenceId]="_projectReferenceId"
              [projectReferencePhoto]="photoReference"
              [readonly]="true"
              (appThrottledClick)="openLightboxModal($any(justifiedLayout), $index)">
            </app-prd-photo>
          }
        </div>
      }
    </app-overflow-content>
  }
}


